import { render } from "./index.vue?vue&type=template&id=7585f09d"
import script from "./home.ts?vue&type=script&lang=js"
export * from "./home.ts?vue&type=script&lang=js"

import "./home.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script